import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
// import { Input as ReactInput, Label } from "@vzrf/react-forms";
import { Input } from "@vds/inputs";
import { TitleLockup } from "@vds/type-lockups";
import { Feature,Body,Title } from "@vds/typography"
import { Redirect } from "react-router-dom";
import { convertStringToElements } from "@vds/html-parsers";

import { media, isMobile } from "utils/style";
import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import styled from "styled-components";

import Button from "common-components/Buttons";
import Loader from "common-components/RectangleLoader";
import CommonContainer from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import GoBack from "common-components/GoBack";
import PropTypes from "prop-types";
import FetchPageContent from "../../../hoc/FetchPageContent";
import { sendSecurePinToDevice } from "./actions/commonFormerCustomerAPI";
import Warning from "../../../../assets/svgs/Warning.svg";
import { encryptData } from "utils/decryptData";
import SuccessInputImg from "../../../../assets/svgs/SuccessInputImg.svg";
import { MaxAttemptsModal } from "./modals";

const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

class FormerCustomerEmailInfo extends Component {
  state = {
    email: "",
    error: "",
    emailValidation: false,
    showMaxAttemptsModal: false,
    errorCheck: true
  };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("email info", this.props.pageContent.sc_pagetitle);
    }
  }

  componentDidUpdate() {
    let message;
    if (this.props.error && this.isJson(this.props.error)) {
      let errorObj = JSON.parse(this.props.error);
      if (errorObj.message && errorObj.message.length > 0) {
        message = errorObj.message.toLowerCase();
        if (this.state.errorCheck) {
          if (message.includes("maximum")) {
            this.setState({ showMaxAttemptsModal: true }, () => { this.setState({ errorCheck: false }) })
          }
        }
      }
    } else if (this.props.error && !(this.isJson(this.props.error))) {
      message = this.props.error.toLowerCase();
      if (this.state.errorCheck) {
        if (message.includes("maximum")) {
          this.setState({ showMaxAttemptsModal: true }, () => { this.setState({ errorCheck: false }) })
        }
      }
    }
  }

  isJson = (str) => {
    
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  handleSubmit = e => {
    e.preventDefault();
    const currentIntent = this.props.location.state && (this.props.location.state.currentIntent ? this.props.location.state.currentIntent : (this.props.location.state.data && this.props.location.state.data.currentIntent ? this.props.location.state.data.currentIntent : null));
    const isOptOut = this.props.location.state && (this.props.location.state.isOptOutChoice ? this.props.location.state.isOptOutChoice : (this.props.location.state.data && this.props.location.state.data.isOptOutChoice ? this.props.location.state.data.isOptOutChoice : null));
    const serviceType = this.props.location.state && (this.props.location.state.serviceType ? this.props.location.state.serviceType : (this.props.location.state.data && this.props.location.state.data.serviceType ? this.props.location.state.data.serviceType : null));
    const { email } = this.state;
    const isMobilePage = "N";
    let formerId;
    if (this.props.location.state.data && this.props.location.state.data.formerUuid) {
      formerId = this.props.formerId ? this.props.formerId : null
    }
    let isValidEmail = false;
    if (!/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email)) {
      isValidEmail = false;
    } else {
      isValidEmail = true;
    }
    if (!isValidEmail) {
      this.setState({ error: "Invalid Email Format" })
    } else {
      let hiddenEmail= encryptData(email);
      this.props.sendSecurePinToDevice(hiddenEmail, currentIntent, isMobilePage, null, formerId).then(() => {

        if (!this.props.error) {       
          var data = {
            emailId: email,
            fname: this.props.location.state.data && this.props.location.state.data.fname ? this.props.location.state.data.fname : null,
            lname: this.props.location.state.data && this.props.location.state.data.lname ? this.props.location.state.data.lname : null,
            currentIntent,
            serviceType,
            isOptOut,
            isMobilePage,
            formerUuid: this.props.location.state.data && this.props.location.state.data.formerUuid ? this.props.location.state.data.formerUuid : null
          }
          this.props.history.replace({
            pathname: "otp-auth",
            state: { data }
          });
        }
      });
    }
  }

  updateEmail = ({ target: { value, name } }) => {
    this.setState({ [name]: value.replace(/[^\w\s/@#$%^&\-\*():;"?_|.,+=!|\\]/gi, "") }, () => {
      if (this.state.error) {
        this.setState({ error: false })
      }
      if (this.state.email && !this.state.email.match(isValidEmail)) {
        this.setState({ emailValidation: false })
      }
    });
  };

  closeMaxAttemptsModal = () => {
    this.setState({ showMaxAttemptsModal: false })
    const serviceType = this.props.location.state &&
      (this.props.location.state.serviceType ?
        this.props.location.state.serviceType :
        (this.props.location.state.data && this.props.location.state.data.serviceType ?
          this.props.location.state.data.serviceType : null
        ));
    if (serviceType === "former") {
      this.props.history.replace({
        pathname: "/privacy/your-data/former-customer"
      })
    } else if (serviceType === "guest") {
      this.props.history.replace({
        pathname: "/privacy/your-data/guest-landing"
      })
    }
  }

  render() {
    
    const { pageContent, loading, location, maxAttemptsModal } = this.props;
    if (!pageContent) {
       if (location.state.data && location.state.data.serviceType === "former" || location.state.serviceType === "former") {
        return <Redirect data-testid="redirect"  to="/privacy/your-data/former-customer" />;
      } else if (location.state.serviceType === "guest") {
        return <Redirect data-testid="redirect" to="/privacy/your-data/guest-landing" />;
      }
    }
    if (loading) {
      return <RectangleLoader id="formerLoader" />;
    }
    const {
      genericList: [{ list: inputList }],
      buttons
    } = pageContent;

    return (
      <div
      id={"headerContainer"}
        onMouseMove={(ev) => {
          if (this.state.email && this.state.email.match(isValidEmail)) {
            this.setState({
              emailValidation: true,
              error: ""
            })
          } else if (this.state.email && !this.state.email.match(isValidEmail)) {
            this.setState({
              error: "Invalid Email Format"
            })
          }
        }}>
        <Fragment>
          <Container>
            {this.props.loading ? (
              <Loader />
            ) : (
              <Fragment>
                {/* VDS DPCMP-3786 ,DPCMP-3784 */}
                <TitleLockup
                  viewport={isMobile ? "mobile": "desktop"}
                  data={{
                  title: {
                    size: 'titleXLarge',
                    bold: false,
                    // primitive: 'h1',
                    children: pageContent.section_title
                  },
                  subtitle : {
                    size: 'titleMedium',
                    primitive: 'p',
                    children: <Body size="large">{convertStringToElements(pageContent.section_description)}</Body>
                  }                  
                  }}
                />
                <form onSubmit={this.handleSubmit}>
                  <div>
                    {inputList &&
                      inputList.length &&
                      inputList.map(({ jsonKey, jsonValue, uniqueId }) => (
                        <Fragment key={uniqueId}>
                          <InputContainer>
                            {/* <Label
                              htmlFor={uniqueId}
                              style={{ fontFamily: "Verizon-NHG-eTX", color: "#000000", fontSize: "12px", lineHeight: "16px" }}
                            >
                              {jsonKey}
                            </Label> */}

                            <Input
                              type="text"
                              label={jsonKey}
                              width={'328px'}
                              // className={this.state.error ? "icon" : this.state.emailValidation ? "successicon" : ""}
                              error={this.state.error ?  true : false}
                              success={this.state.emailValidation ? true: false}
                              errorText={this.props.error || this.state.error ? this.props.error || this.state.error : ""}
                              readOnly={false}
                              disabled={false}
                              id={uniqueId}
                              data-testid="email"
                              data-qm-encrypt="true"
                              name={uniqueId}
                              value={this.state[uniqueId]}
                              maxLength="50"
                              aria-describedby={`${uniqueId}_error`}
                              autoComplete="off"
                              onChange={this.updateEmail}
                              onBlur={() => {
                                if (this.state.email && this.state.email.match(isValidEmail)) {
                                  this.setState({
                                    emailValidation: true,
                                    error: ""
                                  })
                                } else if (this.state.email && !this.state.email.match(isValidEmail)) {
                                  this.setState({
                                    error: "Invalid Email Format"
                                  })
                                }
                              }}
                            />

                            {(this.props.error || this.state.error) && (
                              this.state.showMaxAttemptsModal ?
                                <MaxAttemptsModal
                                  modalContent={maxAttemptsModal}
                                  closeModal={this.closeMaxAttemptsModal}
                                />
                                :
                              null )}
                          </InputContainer>
                        </Fragment>
                      ))}
                  </div>
                  <Button
                    type="submit"
                    disabled={!this.state.email}
                    style={{ marginTop: "48px" }}
                    background={buttons[0].type}
                  >
                    {buttons[0].text}
                  </Button>
                </form>
              </Fragment>
            )}
          </Container>
        </Fragment></div>
    );
  }
}

FormerCustomerEmailInfo.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object
};

const mapStateToProps = ({
  pageContent,
  loadingAndErrorState: { loading, error },
  formerCustomer: { accountInfo: formerCustomerAccountInfo, formerId }
}) => ({
  pageContent: pageContent.email_form,
  maxAttemptsModal: pageContent.maximum_attempts_reached,
  loading,
  error,
  formerCustomerAccountInfo,
  formerId
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, sendSecurePinToDevice }
  ),
  FetchPageContent
)(FormerCustomerEmailInfo);

// const ErrorMsg = styled.span`
//   display: block;
//   font-size: 10px;
//   line-height: 10px;
//   font-family: "Verizon-NHG-eTX",Helvetica, Arial, sans-serif;
//   max-width: 173px;
//   margin-top: 5px;
//   position:absolute;
//   color:#C44904;

//   ${media.mobile`
//     max-width: 100%;  
//   `}
// `;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  width: 490px;
  font-family: 'Verizon NHG DS',Helvetica, Arial, sans-serif;
  font-style: normal;
  padding-bottom: 16px;
  font-weight: 300;
  ${media.mobile`
    max-width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 36px;
    font-family: 'Verizon NHG DS',Helvetica, Arial, sans-serif;
`}
`;

const Div = styled.div`
  max-width: 490px;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  font-family: 'Verizon-NHG-eDS',Helvetica, Arial, sans-serif;
  padding-bottom: 10px;
  ${media.mobile`
  font-size: 16px;
`}
  p {
    padding: 12px 0;
  }
`;

// const StyledInput = styled(Input)`
//   width: 328px;
//   max-width: 424px;
//   ${media.mobile`
//     width: 100%;
//   `}
// `;

const InputContainer = styled.div`
  flex: 50%;
  margin-top: 32px;
  div {
    display: block;
  }
  // .successicon {
  //   padding-left: 25px;
  //   background: url(${SuccessInputImg})no-repeat left;
  //   background-size: 20px;
  //   background-position: 99%;
  //   border: 1px solid  #008331;
  //   border-radius: 4px;
  //   background-color:#DCF5E6;
  // }
  // .icon {
  //   padding-left: 25px;
  //   background: url(${Warning})no-repeat left;
  //   background-size: 20px;
  //   background-position: 99%;
  //   border: 1px solid  #C44904 !important;
  //   background-color:#FBE4D7;
  //   border-radius: 4px;
  // }
  ${media.mobile`
    flex: 100%;
  `}
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: "0";
  padding: 48px 16px ;
  `}
`;